const SectionIntroParent = () => {
    return (
        <section className="py-5">
            <div className="container p-3">
                <div className="row align-items-center">
                    <div className="col-lg-6 text-center mb-4">
                        <img src="/assets/image/guide/parent/aset panduan ortu poin 1.png" className="w-75" alt="" />
                    </div>
                    <div className="col-lg-6">
                        <h2 className="text-blue mb-3 fw-bold">Akses gratis buku <br /> pelajaran resmi <br /> untuk si buah hati</h2>
                        <p>Dapatkan akses buku baik buku teks pelajaran maupun buku non teks, langsung dari Pusat Perbukuan</p>
                        <p>Bapak/ibu dapat mengakses buku dalam berbagai format seperti PDF, audio dan Interaktif.</p>
                        <p>Dapatkan "update" buku teks pelajaran berdasarkan kurikulum yang ada tersedia buku K-13 dan Kurikulum Merdeka.</p>
                    </div>
                </div>
                <div className="row align-items-center mt-5">
                    <div className="col-lg-6 ps-lg-5 order-last order-md-first mt-4 mt-md-0">
                        <h2 className="text-blue mb-3 fw-bold">Bacakan cerita dengan buku paud dan buku non teks</h2>
                        <p>Ayah/ibu dapat mengakses buku paud atau buku non teks
                            untuk membacakan cerita untuk buah hati ayah dan ibu.</p>
                    </div>
                    <div className="col-lg-6 text-center">
                        <img src="/assets/image/guide/parent/aset panduan ortu poin 2.png" className="w-75" alt="" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SectionIntroParent